module.exports = __webpack_public_path__ + "static/img/10.09203f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/zh/10.png
// module id = 3o4i
// module chunks = 0